import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MembershipBenefitsPage } from './membership-benefits.page';

const routes: Routes = [
  {
    path: '',
    component: MembershipBenefitsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MembershipBenefitsPageRoutingModule {}
